import { motion } from "framer-motion";
import { IMG } from "@/lib/images";

const BG_IMG = IMG.LONG_RIDE;

export const FinalCta = () => {
  return (
    <section data-testid="final-section" className="relative py-32 md:py-44 bg-[#0A0A0C] overflow-hidden border-t border-white/5">
      <div className="absolute inset-0 opacity-25">
        <img src={BG_IMG} alt="" style={{ objectPosition: "50% 60%" }} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A0A0C]/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/40 to-[#0A0A0C]" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
        >
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="section-mark" />
            <span className="overline">The Mission</span>
            <span className="section-mark" />
          </div>
          <h2 className="h-display text-white text-4xl sm:text-6xl lg:text-7xl" data-testid="final-headline">
            Built By Riders. <br />
            <span className="text-[#F47A20]">Designed For The Journey.</span>
          </h2>
          <p className="mt-8 text-white/70 text-lg sm:text-xl">
            Built by one stubborn rider. Designed for thousands more.
          </p>
          <div className="serial text-[10px] text-white/40 mt-12">
            ROADRIG AUSTRALIA · ESTABLISHED 2026
          </div>
        </motion.div>
      </div>
    </section>
  );
};
